// equal heights
function equalHeight(group) {
  group.each(function () {
    jQuery(this).css('height', '');
  });
  var tallest = 0;
  group.each(function () {
    var thisHeight = jQuery(this).height();
    if (thisHeight > tallest) {
      tallest = thisHeight;
    }
  });
  group.height(tallest);
}


// video player control
var tag = document.createElement('script');
tag.src = "//www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


var player;
function onYouTubePlayerAPIReady() {
  // create the global player from the specific iframe (#video)
  player = new YT.Player('video', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady
    }
  });
}

function onPlayerReady(event) {

  // bind events
  jQuery('#video_control').on('click', function () {
    jQuery(this).hide();
    jQuery(this).parent().addClass('section_video__inner_play');
    player.playVideo();
//    console.log(1);
  });
}

(function ($) {
  $(function () {


    $('.sb_sm__form input').on('click', function () {
      $('.sb_sm__form').submit();
    });


    // video player control
    $('.video_control').on('click', function () {
      $(this).parent().find('iframe')[0].src += "?rel=0&autoplay=1";
      var $this = $(this);
      $this.fadeOut(500);
      setTimeout(function () {
        $this.parent().addClass('play');
      }, 500);
    });





    $(document).foundation('offcanvas', 'reflow');

    // Magnific popup (Lightbox)
    $('.popup-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: '...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [1,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">Afbeelding #%curr%</a> kan niet worden geladen.',
        titleSrc: function(item) {
          return item.el.attr('title') + ' - <a class="image-source-link" href="'+item.el.attr('data-source')+'" target="_blank">download foto</a>';
        }
      }
    });

    // Lazyload
    $(".lazy").lazyload({
      effect : "fadeIn",
      threshold : 200
    });


    // fast click
    FastClick.attach(document.body);

    // home image slider
    $('#home__slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true
    });

    // home nieuws slider
    $('.home__nieuws__slides').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      fade: true,
      dots: true,
    });

    // toggle menu icon
    $('.menu-icon').on('click', function () {
      $(this).addClass('opened');
    });
    $('.exit-off-canvas').on('click', function () {
      $('.menu-icon').removeClass('opened');
    });

    // toggle menu swipe
    $(".off-canvas-wrap").bind('swipeone', function () {
      if ($(".off-canvas-wrap").hasClass('move-left')) {
        $(".exit-off-canvas").click();
      }
    });




// equal heights
    $(window).load(function () {
      var eqStr = '.n__info';
//      var eqStr2 = '.home__column__inner_w';
      if ($(window).width() > 1024) {
        equalHeight($(eqStr));
//        equalHeight($(eqStr2));
      }

      $(window).resize(function () {
        if ($(window).width() > 1024) {
          equalHeight($(eqStr));
//          equalHeight($(eqStr2));
        }
        else {
          $(eqStr).each(function () {
            $(this).css('height', '');
          });
//          $(eqStr2).each(function () {
//            $(this).css('height', '');
//          });
        }
      });
    });


  });

})(jQuery);